





















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Heading extends Vue {
  @Prop({default: 'h2'})
  private readonly type!: any;

  @Prop()
  private readonly title!: any;

  @Prop()
  private readonly text?: any;
}
